"use strict";

var _classCallCheck = require("/mnt/Data/__Code/__SourceCode/WebProj/Done/hanchakweb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/mnt/Data/__Code/__SourceCode/WebProj/Done/hanchakweb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Connector = void 0;

var Utils_1 = require("../../../../Utils");

var Modes_1 = require("../../../../Enums/Modes");

var Connector =
/*#__PURE__*/
function () {
  function Connector(container) {
    _classCallCheck(this, Connector);

    this.container = container;
  }

  _createClass(Connector, [{
    key: "isEnabled",
    value: function isEnabled() {
      var container = this.container;
      var mouse = container.interactivity.mouse;
      var events = container.options.interactivity.events;

      if (!(events.onHover.enable && mouse.position)) {
        return false;
      }

      var hoverMode = events.onHover.mode;
      return Utils_1.Utils.isInArray(Modes_1.HoverMode.connect, hoverMode);
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function interact() {
      var container = this.container;
      var options = container.options;

      if (options.interactivity.events.onHover.enable && container.interactivity.status === "mousemove") {
        var mousePos = container.interactivity.mouse.position;

        if (!mousePos) {
          return;
        }

        var distance = Math.abs(container.retina.connectModeRadius);
        var query = container.particles.quadTree.query(new Utils_1.Circle(mousePos.x, mousePos.y, distance));
        var i = 0;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = query[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var p1 = _step.value;
            var pos1 = p1.getPosition();
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = query.slice(i + 1)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var p2 = _step2.value;
                var pos2 = p2.getPosition();
                var distMax = Math.abs(container.retina.connectModeDistance);
                var xDiff = Math.abs(pos1.x - pos2.x);
                var yDiff = Math.abs(pos1.y - pos2.y);

                if (xDiff < distMax && yDiff < distMax) {
                  container.canvas.drawConnectLine(p1, p2);
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            ++i;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  }]);

  return Connector;
}();

exports.Connector = Connector;